import moment from 'moment';
import {
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 单数据源筛选器
  SINGLE_SOURCE_SELECT as FILTER_SINGLE_SOURCE_SELECT,
  SINGLE_SOURCE_SELECT_EXTEND_TYPE,
  TIPICON,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { DOUYIN_SOURCES } from '@/pages/intelligence/_config/storeRank/config';

const isValidDate = (date: moment.Moment) =>
  // 选择范围在今天之前
  date.isSameOrBefore(moment(), 'day');

// 筛选器默认配置
export const FILTER_DEFAULT_LIST_MAP = {
  FILTER_RANGE_TIME: {
    savePopupVisble: 1,
    key: FILTER_RANGE_TIME,
    type: FILTER_RANGE_TIME,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
  },
  FILTER_SINGLE_SOURCE_SELECT: {
    savePopupVisble: 1,
    key: FILTER_SINGLE_SOURCE_SELECT,
    type: FILTER_SINGLE_SOURCE_SELECT,
    extendFilterType: SINGLE_SOURCE_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    entityType: 'douyin',
    sources: DOUYIN_SOURCES,
    isNotSaveByDefault: true, // 保存弹窗默认不勾选
  },
  TIPICON: {
    savePopupVisble: 0,
    key: TIPICON,
    visibleinlist: 1,
    content: 'dbi_douyin_filter_info',
  },
};

// 筛选器默认值
export const FILTER_DEFAULT_VALUE = {
  [FILTER_RANGE_TIME]: {
    type: 'date',
    value: [moment(), moment()],
  },
  [FILTER_SINGLE_SOURCE_SELECT]: {
    value: DOUYIN_SOURCES[0],
  },
};

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST = [
  FILTER_DEFAULT_LIST_MAP.FILTER_RANGE_TIME,
  FILTER_DEFAULT_LIST_MAP.FILTER_SINGLE_SOURCE_SELECT,
  FILTER_DEFAULT_LIST_MAP.TIPICON,
];
